import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const SearchField = ({ value, onChange, InputProps = {}, onKeyDown, ...props }) => {
  const { startAdornment, ...restInputProps } = InputProps;

  const handleClear = () => {
    onChange({ target: { value: '' } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') handleClear();
    onKeyDown?.(e);
  };

  return (
    <TextField
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      {...props}
      InputProps={{
        startAdornment: startAdornment ?? (
          <InputAdornment position="start">
            <SearchIcon color="action" fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear} edge="end" tabIndex={-1}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
        ...restInputProps,
      }}
    />
  );
};

export default SearchField;
